import { compact, curry, get, head, map, pipe } from 'lodash/fp';
var getWithFallback = curry(function (paths, object) {
  return pipe(map(function (path) {
    return get(path, object);
  }), compact, head)(paths);
});
export default getWithFallback;